// components/admin/EditUserModal.tsx
import React, { useEffect, useState } from 'react';
import { User } from '../../types/user';


interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    user: User | null;
}

export default function EditUserModal({ isOpen, onClose, onSuccess, user }: Props) {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [subscription, setSubscription] = useState('free');
    const [configCount, setConfigCount] = useState(0);
    const [error, setError] = useState('');

    useEffect(() => {
        if (user) {
            setFirstName(user.firstName);
            setLastName(user.lastName);
            setEmail(user.email);
            setSubscription(user.subscription);
            setConfigCount(user.configCount);
        }
    }, [user]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const token = localStorage.getItem('adminToken');
        const url = user ? `/api/admin/users/${user._id}` : '/api/admin/users/create';
        const method = user ? 'PUT' : 'POST';

        const res = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                firstName,
                lastName,
                email,
                subscription,
                configCount,
            }),
        });

        const data = await res.json();
        if (!res.ok) {
            setError(data.message || 'Fehler');
            return;
        }

        if (onSuccess) onSuccess();
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded shadow-lg w-full max-w-md text-black">
                <h2 className="text-xl font-bold mb-4">{user ? 'Benutzer bearbeiten' : 'Benutzer erstellen'}</h2>
                <form onSubmit={handleSubmit} className="space-y-3">
                    <input className="w-full border p-2" placeholder="Vorname" value={firstName} onChange={e => setFirstName(e.target.value)} />
                    <input className="w-full border p-2" placeholder="Nachname" value={lastName} onChange={e => setLastName(e.target.value)} />
                    <input className="w-full border p-2" placeholder="E-Mail" type="email" value={email} onChange={e => setEmail(e.target.value)} />
                    <select className="w-full border p-2" value={subscription} onChange={e => setSubscription(e.target.value)}>
                        <option value="free">Free</option>
                        <option value="premium">Premium</option>
                    </select>
                    <input className="w-full border p-2" type="number" placeholder="Anzahl Configs" value={configCount} onChange={e => setConfigCount(Number(e.target.value))} />

                    {error && <div className="text-red-600 text-sm">{error}</div>}

                    <div className="flex justify-end gap-2">
                        <button type="button" className="px-4 py-2 border" onClick={onClose}>Abbrechen</button>
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white">{user ? 'Speichern' : 'Erstellen'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
